<template>
  <div class="psPatientWeekendDetail">
    <div class="row">
      <div class="column w-100">
        <div class="label">Resumen mensual</div>
        <el-input 
          type="textarea"
          :rows="5"
          :maxlength="1000"
          show-word-limit
          :value="itemWeekend.description" 
          @input="PATIENTS_ITEM_WEEKEND_PROP({property: 'description', value: $event})"
        ></el-input>
      </div>
      <div class="column" v-if="itemWeekend.id > 0">
        <div class="label">&nbsp;</div>
        <el-button type="danger" icon="el-icon-delete" plain @click="deleteWeekend"></el-button>
      </div>
    </div>
    <el-button @click="saveWeekend" icon="el-icon-check" type="success" round class="btnSave" :disabled="itemWeekend.description == ''">{{ itemWeekend.id > 0 ? 'Actualizar' : 'Guardar' }}</el-button>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  name: 'PsPatientWeekendDetail',
  computed: {
    ...mapState('patients', ['itemWeekend'])
  },
  methods: {
    ...mapMutations('patients', ['PATIENTS_ITEM_WEEKEND_PROP', 'PATIENTS_DIALOG_WEEKEND']),
    ...mapActions('patients', ['saveWeekendPatient', 'getPatientHTTP', 'deleteWeekendPatientHTTP']),
    async saveWeekend () {
      let loading
      try {
        loading = this.$loading({
          lock: true,
          text: 'Guardando...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });   

        const message = await this.saveWeekendPatient()
        this.$message( { message, type: 'success' } )
        setTimeout( async () => {
          await this.getPatientHTTP( this.$route.params['patientId'])
          loading.close()
          this.PATIENTS_DIALOG_WEEKEND(false)
        }, 1000)
      } catch ( err ) { this.$message( { message: err.response.data.err.details, type: 'error' })}
      finally { loading.close()}
     
    },
    async deleteWeekend () {
      let loading
      try {
        this.$confirm('¿Quiere eliminar esta actividad de resumen mensual?', 'Confirmación', {
          type: 'warning',
          confirmButtonText: 'Si',
          cancelButtonText: 'No'
        })
        .then( async () => {
          loading = this.$loading({
            lock: true,
            text: 'Eliminando...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          }); 
          const message = await this.deleteWeekendPatientHTTP()
          setTimeout( async () => {
            await this.getPatientHTTP( this.$route.params['patientId'])
            this.PATIENTS_DIALOG_WEEKEND(false)
            loading.close()
            this.$message.success(message)
          }, 1000)
        })
        .catch( () => {})
      } catch ( err ) { this.$message.error('No se pudo eliminar esta actividad de resumen mensual.')}
    }
  }
}
</script>

<style>

</style>